import { useState } from "react";
import AutoComplete, { AutoCompleteOnSelectedItemChange } from "./AutoComplete";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_KURSUS_AUTOCOMPLETE_QUERY } from "../../api/kursus/queries";
import { AutoCompleteItem, KursusAutoCompleteResponse } from "./interface";
import KursusIcon from "../icons/KursusIcon";

export default function AutoCompleteKursus({
  className,
  isInvalidClass,
  clearAfterSelection,
  includeFirstItem,
  onSelectedItemChange,
  placeholder,
  focusInputOnMount,
  onInputBlur,
}: {
  className?: string;
  isInvalidClass?: string;
  clearAfterSelection?: boolean;
  onSelectedItemChange?: AutoCompleteOnSelectedItemChange;
  placeholder?: string;
  includeFirstItem: boolean;
  focusInputOnMount?: boolean;
  onInputBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
}) {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const { data, loading } = useQuery<{
    kursusholds: {
      edges: {
        node: KursusAutoCompleteResponse;
      }[];
    };
  }>(
    GET_KURSUS_AUTOCOMPLETE_QUERY({
      q: inputValue,
    }),
    {
      variables: { q: inputValue },
      skip: !inputValue,
    },
  );

  const items =
    !loading && data && data.kursusholds.edges.length > 0
      ? data.kursusholds.edges.map(({ node }) => {
          const item: AutoCompleteItem<number> = {
            id: node.id,
            header: node.navn,
            subheader: `Holdnr: ${node.holdNr}`,
            icon: <KursusIcon width={20} height={20} />,
            data: node.kursustype,
          };
          return item;
        })
      : [];

  const defaultOnSelectedItemChange: AutoCompleteOnSelectedItemChange = ({
    selectedItem,
  }) => {
    if (selectedItem) {
      if (selectedItem.id) {
        navigate(`/kursus/${selectedItem.id}`, { replace: false });
      } else {
        navigate(`/kursus?q=${inputValue}`, {
          replace: true,
        });
      }
    }
  };

  return (
    <AutoComplete<any>
      isInvalidClass={isInvalidClass}
      className={className}
      clearAfterSelection={clearAfterSelection}
      includeFirstItem={includeFirstItem}
      items={items}
      itemToString={(item) => (item?.header as string) ?? ""}
      loading={loading}
      placeholder={placeholder ?? "Søg på kursus ..."}
      setInputValue={setInputValue}
      onSelectedItemChange={onSelectedItemChange ?? defaultOnSelectedItemChange}
      focusInputOnMount={focusInputOnMount}
      onInputBlur={onInputBlur}
    />
  );
}
